import lodashGet from "lodash/get";
import React, { ComponentPropsWithoutRef } from "react";
import { PillarTableBaseColumnCellValuePathProps } from "shared/components/pillar-table/columns/PillarTableColumn";
import { PillarTableRowContext, usePillarTableRowContext } from "shared/components/pillar-table/row/PillarTableRowContext";
import { formatUsdString } from "shared/helpers/invoice/formatUsdString";

const PillarTableColumnUSD = <T,>({
  cellValuePath,
}: PillarTableBaseColumnCellValuePathProps<T> &
  ComponentPropsWithoutRef<"div">) => {
  const rowContext = usePillarTableRowContext();
  const rowValue = lodashGet(rowContext?.rowValue, cellValuePath ?? "") as unknown as number;

  return rowValue || rowValue === 0 ? <>{formatUsdString(rowValue)}</> : <></>;
};

export default PillarTableColumnUSD;
